export const LANGUAGES = [
	{ id: 1, code: 'fr' },
	{ id: 2, code: 'en' },
]
